type DocumentIconProps = {
  width?: number;
  height?: number;
  color?: string;
};

export const DocumentIcon = ({
  width = 25,
  height = 29,
  color = "#3F4756",
}: DocumentIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.588 9.792h1.125M9.471 9.864h11.726M6.588 12.738h1.125M9.471 12.81h11.726M6.588 15.683h1.125M9.471 15.755h11.726M6.588 18.629h1.125M9.471 18.7h11.726M6.588 21.574h1.125M9.471 21.646h11.726"
      stroke={color}
      strokeLinecap="round"
    />
    <path
      d="M24 7.382v17.473a.2.2 0 0 1-.2.2h-2.3M24 7.382 17.5 1M24 7.382h-6.3a.2.2 0 0 1-.2-.2V1m0 0H4.2a.2.2 0 0 0-.2.2v1.764m0 0v21.89c0 .111.09.2.2.2h17.3M4 2.965H1.2a.2.2 0 0 0-.2.2V27.8c0 .11.09.2.2.2h20.1a.2.2 0 0 0 .2-.2v-2.745M6.7 7.873h2.6a.2.2 0 0 0 .2-.2V5.618a.2.2 0 0 0-.2-.2H6.7a.2.2 0 0 0-.2.2v2.055c0 .11.09.2.2.2z"
      stroke={color}
    />
  </svg>
);
